import { Phone, Mail, MapPin, MessageCircle } from "lucide-react";

const pill = "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 font-semibold transition-colors";
const tel = (t) => t.replace(/[^\d+]/g, "");

// Recapiti installatore e, se presente, personale dedicato con chiamata e WhatsApp
export function InstallatoreCard({ i }) {
  return (
    <div>
      <b className="block text-slate-800" data-testid="cliente-installatore-nome">{i.nome}</b>
      {i.azienda && <span className="block text-xs font-semibold text-slate-400" data-testid="cliente-installatore-azienda">{i.azienda}</span>}
      <div className="mt-2 flex flex-wrap gap-2 text-sm">
        {i.telefono && <a href={`tel:${tel(i.telefono)}`} className={`${pill} bg-sky-50 text-sky-700 hover:bg-sky-100`} data-testid="cliente-installatore-tel"><Phone className="h-4 w-4" />{i.telefono}</a>}
        {i.email && <a href={`mailto:${i.email}`} className={`${pill} bg-sky-50 text-sky-700 hover:bg-sky-100`} data-testid="cliente-installatore-mail"><Mail className="h-4 w-4" />{i.email}</a>}
        {i.indirizzo && <a href={`https://maps.google.com/?q=${encodeURIComponent(i.indirizzo)}`} target="_blank" rel="noreferrer" className={`${pill} bg-slate-50 text-slate-600 hover:bg-slate-100`} data-testid="cliente-installatore-sede"><MapPin className="h-4 w-4" />{i.indirizzo}</a>}
      </div>
      {i.personale?.length > 0 && (
        <div className="mt-4 space-y-2" data-testid="cliente-personale">
          <span className="text-[11px] font-bold uppercase tracking-wider text-slate-400">Personale dedicato</span>
          {i.personale.map((p, k) => (
            <div key={p.telefono} className="flex items-center gap-3 rounded-2xl bg-slate-50 px-3 py-2.5" data-testid={`cliente-personale-${k}`}>
              <div className="min-w-0 flex-1">
                <b className="block text-sm text-slate-800">{p.nome}</b>
                <span className="block text-xs text-slate-500">{p.ruolo} · {p.telefono}</span>
              </div>
              <a href={`tel:${tel(p.telefono)}`} aria-label={`Chiama ${p.nome}`} className="flex h-10 w-10 items-center justify-center rounded-full bg-sky-100 text-sky-700 hover:bg-sky-200" data-testid={`cliente-personale-chiama-${k}`}><Phone className="h-4 w-4" /></a>
              <a href={`https://wa.me/${tel(p.telefono).replace("+", "")}`} target="_blank" rel="noreferrer" aria-label={`WhatsApp ${p.nome}`} className="flex h-10 w-10 items-center justify-center rounded-full bg-emerald-100 text-emerald-700 hover:bg-emerald-200" data-testid={`cliente-personale-wa-${k}`}><MessageCircle className="h-4 w-4" /></a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
